module.exports = __webpack_public_path__ + "static/media/alba.ed418d7c.jpg";